// extracted by mini-css-extract-plugin
module.exports = {"errorNotification":"errorNotification-2OPjk","errorNotificationText":"errorNotificationText-10iMc"};